import MailLogCheck from './API/MailLogCheck';

const API = {
	MailLogCheck         : MailLogCheck,
};


export default API;
